// extracted by mini-css-extract-plugin
export var style_dialogMenu = "MobileUnauthenticatedHeaderMenu-module--style_dialogMenu--370f9 theme--baseText--70927 theme--text--a5fab";
export var style_dialogMenuItem = "MobileUnauthenticatedHeaderMenu-module--style_dialogMenuItem--16f15";
export var style_link = "MobileUnauthenticatedHeaderMenu-module--style_link--0840a";
export var style_profileButton = "MobileUnauthenticatedHeaderMenu-module--style_profileButton--6d400";
export var textFamily = "var(--textFamily)";
export var theme = "\"@theme.css\"";